import { render, staticRenderFns } from "./PressEntryThumb.vue?vue&type=template&id=13a5f53a&lang=pug&"
import script from "./PressEntryThumb.vue?vue&type=script&lang=js&"
export * from "./PressEntryThumb.vue?vue&type=script&lang=js&"
import style0 from "./PressEntryThumb.vue?vue&type=style&index=0&id=13a5f53a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports